/**
 * Created by BFR on 06/09/2022.
 */
define('ordersDetailPriceV2PrintPricesView',[
  'app',
  'module',
  'backbone',
  'marionette',
  'jquery',
  'underscore',
  'settings',
  'template!ordersDetailPriceV2PrintPricesView',
  'ordersDetailPriceV2PrintPriceView',
  'entities/product',
  'entities/pim_product'
], function (
  App,
  module,
  Backbone,
  Marionette,
  $,
  _,
  Settings,
  viewTpl,
  orderPrintPriceV2ItemView
) {
  'use strict';

  module.exports = Marionette.CompositeView.extend({
    template: viewTpl,
    childViewContainer: '.items-region',
    childView: orderPrintPriceV2ItemView,

    childViewOptions: function () {
      return {
        advancedMode: Settings.configValue('advancedMode') === true
      };
    },

    events: {
      'change .select-nbr-colors': 'onSelectNbrColorsChange'
    },

    initialize: function () {
      var config = {
        quantity: 500,
        options: [],
        printZonesColors: {}
      };

      _.each(this.options.product.get('productOptionCategories'), function (poc) {
        config.options.push(poc.productOptions[0].id);
      });

      _.each(this.options.product.get('printAreas'), function (pa) {
        _.each(pa.printZones, function (pz) {
          config.printZonesColors[pz.id] = 1;
        });
      });

      var request;
      if (this.options.product.get('pim')) {
        request = App.request('pim:products:get-price-for-configuration', this.options.product.get('secId'), config, true);
      } else {
        request = App.request('products:get-price-for-configuration', this.options.product.get('secId'), config, true);
      }
      var picturesRequest = this.loadPrintPictures();
      $.when(request, picturesRequest).done(_.bind(function (price, pzPictures) {
        this.price = price;
        var items = [];
        _.each(price.impt, _.bind(function (impt) {
          var comp = _.findWhere(this.model.get('order').get('compositions'), {pzId: impt.secId});
          var item = {
            setup: Number(impt.imptSetupPrice).toFixed(2),
            handlingPrice: impt.imptHandlingPrice ? Number(impt.imptHandlingPrice).toFixed(2) : '0',
            scales: [],
            checked: !!comp,
            composition: comp,
            order: this.model
          };
          _.each(this.options.product.get('printAreas'), function (pa) {
            _.each(pa.printZones, function (pz) {
              if (pz.id === impt.secId) {
                item.pa = pa;
                item.pz = _.extend({}, pz, {printPictures: pzPictures[pz.id] || pz.printPictures || []});
              }
            });
          });
          this.scales = price.scale;

          if (this.options.factorsV2 && !price.customScales) {
            this.scales = _.filter(price.scale, _.bind(function (scale) {
              if (Number(scale.total) === 0 || (Number(scale.total) > this.options.factorsV2.param2 &&
                (!this.options.factorsV2.param3 ||
                  this.options.factorsV2.param3 === 0 ||
                  Number(scale.total) < this.options.factorsV2.param3))) {
                return true;
              }
              return false;
            }, this));
          }

          _.each(this.scales, function (scale) {
            var imptS = _.findWhere(scale.impt, {secId: impt.secId});
            var s = {
              quantity: scale.quantity,
              unit: Number(imptS.imptUnitUnitPrice).toFixed(2)
            };
            item.scales.push(s);
          });

          items.push(item);
        }, this));
        this.collection = new Backbone.Collection(items);
        this.render();
      }, this));
    },

    loadPrintPictures: function () {
      var defer = $.Deferred();
      var pzPictures = {};
      if (Settings.configValue('advancedMode') !== true) {
        defer.resolve(pzPictures);
        return defer.promise();
      }
      var product = this.options.product;

      if (product.get('pim')) {
        var pimProduct = App.request('pim:products:model', {id: this.model.get('order').get('productSecId')});
        pimProduct.fetch().done(function () {
          var data = pimProduct.get('data');
          if (data && data.get('printAreas')) {
            data.get('printAreas').each(function (pa) {
              pa.get('printZones').each(function (pz) {
                pzPictures[pz.get('pimId')] = pz.get('printPictures') || [];
              });
            });
          }
          defer.resolve(pzPictures);
        }).fail(function () {
          defer.resolve(pzPictures);
        });
      } else {
        App.request('product:get-printareas', product.get('code')).done(function (printAreas) {
          _.each(printAreas, function (pa) {
            _.each(pa.printZones, function (pz) {
              pzPictures[pz.id] = pz.printPictures || [];
            });
          });
          defer.resolve(pzPictures);
        });
      }

      return defer.promise();
    },

    onSelectNbrColorsChange: function () {

    },

    serializeData: function () {
      var templateData = {};
      templateData.scales = this.scales || [];
      templateData.advancedMode = Settings.configValue('advancedMode') === true;
      return templateData;
    }
  });
});
